<template>
  <div class="detail-page">

    <!-- ===== 01. 메인 비주얼 ===== -->
    <section class="dp-hero">
      <img :src="require('@/assets/1.png')" alt="메인 비주얼" class="dp-hero-img" />
      <img :src="require('@/assets/2.png')" alt="메인 비주얼 2" class="dp-hero-img" />
    </section>

    <!-- ===== 사업 개요 ===== -->
    <section class="sec sec-overview">
      <div class="sec-inner">
        <p class="sec-eyebrow">BUSINESS OVERVIEW</p>
        <h2 class="section-title">사업 개요</h2>

        <img :src="require('@/assets/사업개요.jpg')" alt="사업 개요" class="overview-img" />

        <table class="overview-table">
          <tbody>
            <tr>
              <th>사업명</th>
              <td>김포 칸타빌 에디션</td>
            </tr>
            <tr>
              <th>대지위치</th>
              <td>경기도 김포시 북변동 224-67 일원</td>
            </tr>
            <tr>
              <th>건축규모</th>
              <td>지하 5층 ~ 지상 24층, 9개동</td>
            </tr>
            <tr>
              <th>세대수</th>
              <td>총 612세대 (66㎡, 84㎡, 104㎡, 127㎡)</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- ===== 프리미엄 ===== -->
    <section class="sec sec-premium">
      <div class="sec-inner">
        <p class="sec-eyebrow">PREMIUM</p>
        <h2 class="section-title">프리미엄</h2>

        <div class="premium-grid">

          <!-- 01 북변새도시 -->
          <div class="premium-card">
            <div class="premium-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/>
                <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/>
                <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/>
                <path d="M10 6h4"/><path d="M10 10h4"/><path d="M10 14h4"/><path d="M10 18h4"/>
              </svg>
            </div>
            <p class="premium-label">Premium <span>01</span></p>
            <p class="premium-desc">총 7천여 세대로 완성되는</p>
            <p class="premium-headline">북변새도시<br/>대변화의 중심</p>
          </div>

          <!-- 02 5호선 연장 -->
          <div class="premium-card">
            <div class="premium-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M8 3.1V7a4 4 0 0 0 8 0V3.1"/>
                <path d="M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z"/>
                <path d="m9 15-1-1"/><path d="m15 15 1-1"/>
                <path d="m8 19-2 3"/><path d="m16 19 2 3"/>
              </svg>
            </div>
            <p class="premium-label">Premium <span>02</span></p>
            <p class="premium-desc">5호선 연장(추진)으로</p>
            <p class="premium-headline">서울 중심을 환승없이<br/>바로 연결</p>
          </div>

          <!-- 03 교통 네트워크 -->
          <div class="premium-card">
            <div class="premium-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="6" cy="19" r="3"/>
                <path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"/>
                <circle cx="18" cy="5" r="3"/>
              </svg>
            </div>
            <p class="premium-label">Premium <span>03</span></p>
            <p class="premium-desc">걸포북변역, 김포한강로 등</p>
            <p class="premium-headline">빠르고 편리한<br/>교통 네트워크</p>
          </div>

          <!-- 04 생활인프라 -->
          <div class="premium-card">
            <div class="premium-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/>
                <path d="M3 6h18"/>
                <path d="M16 10a4 4 0 0 1-8 0"/>
              </svg>
            </div>
            <p class="premium-label">Premium <span>04</span></p>
            <p class="premium-desc">홈플러스, 대형병원, 김포근린공원 등</p>
            <p class="premium-headline">풍부한<br/>생활인프라</p>
          </div>

          <!-- 05 교육환경 -->
          <div class="premium-card">
            <div class="premium-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
                <path d="M6 12v5c3 3 9 3 12 0v-5"/>
              </svg>
            </div>
            <p class="premium-label">Premium <span>05</span></p>
            <p class="premium-desc">김포초, 김포중, 김포고 등</p>
            <p class="premium-headline">도보거리의 우수한<br/>교육환경</p>
          </div>

          <!-- 06 특화설계 -->
          <div class="premium-card">
            <div class="premium-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/>
                <path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/>
              </svg>
            </div>
            <p class="premium-label">Premium <span>06</span></p>
            <p class="premium-desc">넓은 알파룸, 다수의 테라스 등</p>
            <p class="premium-headline">칸타빌만의 여유로운<br/>특화설계</p>
          </div>

        </div>
      </div>
    </section>

    <!-- ===== 입지환경 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">LOCATION</p>
        <h2 class="section-title">입지환경</h2>
      </div>
      <img :src="require('@/assets/입지환경.jpg')" alt="입지환경" class="community-img" />

      <div class="location-grid">
        <div class="location-card">
          <div class="loc-head">
            <span class="loc-num">01</span>
            <span class="loc-cat">빠른 교통망</span>
          </div>
          <p class="loc-detail">걸포북변역, 인천2호선 연장(예정), 서울5호선 연장(추진), 태장로, 김포대로</p>
        </div>
        <div class="location-card">
          <div class="loc-head">
            <span class="loc-num">02</span>
            <span class="loc-cat">완벽한 생활</span>
          </div>
          <p class="loc-detail">홈플러스, CGV, 김포시청, 행정복지센터, 김포우리병원, 단지 앞 김포근린공원</p>
        </div>
        <div class="location-card">
          <div class="loc-head">
            <span class="loc-num">03</span>
            <span class="loc-cat">안심 교육환경</span>
          </div>
          <p class="loc-detail">중봉시립도서관, 김포초, 김포중, 김포여중, 김포고, 사우고 등 가까운 교육 인프라</p>
        </div>
        <div class="location-card">
          <div class="loc-head">
            <span class="loc-num">04</span>
            <span class="loc-cat">눈부신 비전</span>
          </div>
          <p class="loc-detail">인근 한강시네폴리스 산업단지(예정), 김포한강2콤팩트시티(예정), GTX-D(예정)</p>
        </div>
      </div>
    </section>

    <!-- ===== 단지 배치 ===== -->
    <section class="sec sec-layout">
      <div class="sec-inner">
        <p class="sec-eyebrow">SITE PLAN</p>
        <h2 class="section-title">단지 배치</h2>
      </div>
      <img :src="require('@/assets/단지배치도.jpg')" alt="단지 배치" class="layout-img" />
    </section>

    <!-- ===== 단지 안내 ===== -->
    <section class="sec sec-layout">
      <div class="sec-inner">
        <p class="sec-eyebrow">SITE GUIDE</p>
        <h2 class="section-title">단지 안내</h2>
      </div>
      <img :src="require('@/assets/단지안내.jpg')" alt="단지 안내" class="layout-img" />
    </section>

    <!-- ===== 세대정보 ===== -->
    <section class="sec sec-unit">
      <div class="sec-inner">
        <p class="sec-eyebrow">UNIT PLAN</p>
        <h2 class="section-title">세대정보</h2>

        <!-- 유닛 타입 탭 (가로 스크롤) -->
        <div class="unit-tabs-wrap">
          <div class="unit-tabs">
            <button
              v-for="tab in unitTabs"
              :key="tab.id"
              class="unit-tab"
              :class="{ active: activeUnit === tab.id }"
              @click="activeUnit = tab.id"
            >
              <span class="unit-tab-label">{{ tab.label }}</span>
              <span v-if="tab.tag" class="unit-tab-tag">{{ tab.tag }}</span>
            </button>
          </div>
        </div>

        <!-- 활성 유닛 라벨 -->
        <div class="unit-current">
          <span class="unit-current-name">{{ activeUnit }}</span>
          <span v-if="activeUnitTag" class="unit-current-tag">{{ activeUnitTag }}</span>
        </div>

        <!-- 평면 이미지 -->
        <transition name="fade" mode="out-in">
          <div class="unit-stack" :key="activeUnit">
            <figure class="unit-figure">
              <img :src="unitPlanImage" :alt="`${activeUnit} 평면도`" class="unit-img" />
            </figure>
          </div>
        </transition>
      </div>
    </section>

    <!-- ===== 커뮤니티 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">COMMUNITY</p>
        <h2 class="section-title">커뮤니티</h2>
      </div>
      <img :src="require('@/assets/커뮤니티.jpg')" alt="커뮤니티" class="community-img" />
    </section>

    <!-- ===== 10. 방문예약 ===== -->
    <section class="dp-register" ref="secRegister">
      <div class="dp-section-inner">
        <p class="dp-eyebrow light">CONTACT</p>
        <h2 class="dp-section-title light">방문예약</h2>
        <p class="dp-register-desc">상담을 원하시면 아래 정보를 입력해주세요.</p>

        <div v-if="!isSubmitted">
          <form @submit.prevent="submitForm" class="dp-form">
            <div class="dp-field">
              <label>이름 <span class="dp-req">*</span></label>
              <input type="text" v-model="formData.name" placeholder="이름을 입력해주세요" required />
            </div>
            <div class="dp-field">
              <label>연락처 <span class="dp-req">*</span></label>
              <div class="dp-phone">
                <input type="tel" inputmode="numeric" ref="p1" v-model="formData.phone1" placeholder="010" maxlength="3" required @input="onPhoneInput('phone1', 3, 'p2')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="p2" v-model="formData.phone2" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone2', 4, 'p3')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="p3" v-model="formData.phone3" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone3', 4, null)" />
              </div>
            </div>
            <div class="dp-field">
              <label>원하시는 방문일 <span class="dp-req">*</span></label>
              <div class="dp-date-stack">
                <div class="dp-date-wrap">
                  <input type="date" v-model="formData.visitDate" :min="todayStr"
                         :disabled="formData.consultLater" class="dp-date-input" />
                  <span v-if="!formData.visitDate && !formData.consultLater" class="dp-date-placeholder">📅 방문일 선택</span>
                </div>
                <select v-model="formData.visitTime" :disabled="formData.consultLater" class="dp-select">
                  <option value="" disabled>⏰ 방문시간 선택</option>
                  <option v-for="t in visitTimes" :key="t" :value="t">{{ t }}</option>
                </select>
              </div>
              <button type="button" class="dp-later-btn"
                      :class="{ active: formData.consultLater }"
                      @click="toggleConsultLater">상담 후 결정</button>
            </div>
            <label class="dp-agree">
              <input type="checkbox" v-model="formData.agree" required />
              <span class="dp-check"></span>
              <span>개인정보 수집 및 이용에 동의합니다.</span>
            </label>
            <button type="submit" class="dp-submit" :disabled="isSubmitting">
              {{ isSubmitting ? '전송 중...' : '방문예약 신청' }}
            </button>
          </form>
        </div>

        <div v-else class="dp-success">
          <div class="dp-success-icon">&#10003;</div>
          <h3>신청이 완료되었습니다</h3>
          <p>빠른 시일 내에 연락드리겠습니다.</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'MainView',
  data() {
    return {
      observers: [],
      activeUnit: '66A',
      isSubmitting: false,
      isSubmitted: false,
      formData: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDate: '',
        visitTime: '',
        consultLater: false,
        agree: false
      },
      visitTimes: [
        '10:00', '10:30', '11:00', '11:30',
        '12:00', '12:30', '13:00', '13:30',
        '14:00', '14:30', '15:00', '15:30',
        '16:00', '16:30', '17:00', '17:30', '18:00'
      ],
      unitTabs: [
        { id: '66A', label: '66A' },
        { id: '66B', label: '66B' },
        { id: '84A', label: '84A' },
        { id: '84B', label: '84B' },
        { id: '104A', label: '104A' },
        { id: '104B', label: '104B' },
        { id: '127A', label: '127A' },
        { id: '127B', label: '127B' }
      ],
      premiumItems: [
        {
          title: '서수원<br/>미래가치',
          desc: '새로운 개발축인<br/>서수원 레벨을 높일 미래가치'
        },
        {
          title: '신도시급<br/>주거벨트',
          desc: '당수 1·2지구(계획), 호매실지구 포함<br/>33,000여 세대 본격 개발'
        },
        {
          title: '분양가<br/>상한제',
          desc: '분양가 상한제로 누릴<br/>프리미엄의 격차'
        },
        {
          title: '신분당선<br/>호매실역',
          desc: '신분당선 호매실역(\'29년 개통예정)으로<br/>더 빨라지고 가까워질 서울'
        },
        {
          title: '당수지구<br/>랜드마크',
          desc: '당수지구 최중심을 가진<br/>최고층 랜드마크의 격조'
        },
        {
          title: '공세권<br/>슬세권',
          desc: '공세권, 슬세권으로<br/>어디든 원스톱으로 누릴 자격'
        },
        {
          title: '3면 발코니<br/>4Bay 설계',
          desc: '레벨이 다른 실사용 면적<br/>(일부세대)'
        },
        {
          title: '남향 설계<br/>동간 이격',
          desc: '남향 위주 설계, 전세대 전망의<br/>간섭없는 동간 이격배치'
        }
      ]
    }
  },
  computed: {
    unitPlanImage() {
      return require(`@/assets/unit/${this.activeUnit}.jpg`)
    },
    activeUnitTag() {
      return this.unitTabs.find(t => t.id === this.activeUnit)?.tag || ''
    },
    todayStr() {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    }
  },
  mounted() {
    this.setupObservers()
    setTimeout(() => {
      window.dispatchEvent(new Event('open-register-popup'))
    }, 1200)
  },
  beforeUnmount() {
    this.observers.forEach(ob => ob.disconnect())
  },
  methods: {
    setupObservers() {
      this.$nextTick(() => {
        const scenes = this.$el?.querySelectorAll('.story-scene') || []
        scenes.forEach((scene) => {
          const ob = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              scene.classList.add('show')
              ob.disconnect()
            }
          }, { threshold: 0.15 })
          ob.observe(scene)
          this.observers.push(ob)
        })
      })
    },
    scrollToForm() {
      this.$refs.secRegister?.scrollIntoView({ behavior: 'smooth' })
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.formData[field] = this.formData[field].replace(/[^0-9]/g, '')
      if (this.formData[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    toggleConsultLater() {
      this.formData.consultLater = !this.formData.consultLater
      if (this.formData.consultLater) {
        this.formData.visitDate = ''
        this.formData.visitTime = ''
      }
    },
    formatVisitDate(dateStr) {
      if (!dateStr) return ''
      const days = ['일','월','화','수','목','금','토']
      const d = new Date(dateStr)
      const y = dateStr.slice(0, 4)
      const m = dateStr.slice(5, 7)
      const dd = dateStr.slice(8, 10)
      return `${y}.${m}.${dd}(${days[d.getDay()]})`
    },
    async submitForm() {
      if (!this.formData.consultLater) {
        if (!this.formData.visitDate || !this.formData.visitTime) {
          alert('방문일과 시간을 선택하거나 "상담 후 결정"을 선택해주세요.')
          return
        }
      }
      if (!this.formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      const consultTime = this.formData.consultLater
        ? '상담 후 결정'
        : `${this.formatVisitDate(this.formData.visitDate)} ${this.formData.visitTime}`
      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.formData.name,
          phone: `${this.formData.phone1}${this.formData.phone2}${this.formData.phone3}`,
          consultTime,
          source: 'website'
        })
        this.isSubmitted = true

        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_5a3399ef72b5'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
/* ===== 기본 ===== */
.detail-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #fff;
  overflow-x: hidden;
  padding-bottom: 120px;
}

.dp-section-inner {
  max-width: 560px;
  margin: 0 auto;
  padding: 72px 28px;
}

.dp-num {
  display: inline-block;
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 48px;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.06);
  line-height: 1;
  margin-bottom: 8px;
}

.dp-num.light {
  color: rgba(255, 255, 255, 0.1);
}

.dp-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #3f3536;
  margin-bottom: 16px;
}

.dp-eyebrow.light {
  color: rgba(255, 255, 255, 0.4);
}

.dp-section-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 28px;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 1.5;
  margin-bottom: 40px;
}

.dp-section-title strong {
  font-weight: 800;
}

.dp-section-title.light {
  color: rgba(255, 255, 255, 0.6);
}

.dp-section-title.light strong {
  color: #fff;
}

/* ===== 01. 메인 비주얼 ===== */
.dp-hero {
  width: 100%;
  line-height: 0;
}

.dp-hero-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 02. 프로젝트 스토리 (5씬) ===== */
.dp-story {
  background: linear-gradient(180deg, #2a2324 0%, #3f3536 100%);
  padding: 80px 0 100px;
  position: relative;
  overflow: hidden;
}

.dp-story::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    radial-gradient(circle at 15% 12%, rgba(255, 211, 107, 0.10), transparent 40%),
    radial-gradient(circle at 85% 88%, rgba(255, 211, 107, 0.06), transparent 40%);
  pointer-events: none;
}

/* -- 섹션 헤더 -- */
.story-hero {
  text-align: center;
  padding: 0 28px 56px;
  position: relative;
  z-index: 1;
}

.story-hero-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 6px;
  color: rgba(255, 211, 107, 0.85);
  margin-bottom: 24px;
}

.story-hero-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 38px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.3;
  margin-bottom: 28px;
  letter-spacing: -1px;
}

.story-hero-title strong {
  font-weight: 900;
  background: linear-gradient(135deg, #fff 0%, #ffd36b 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.story-hero-divider {
  width: 56px;
  height: 3px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
  margin: 0 auto;
  border-radius: 2px;
}

/* -- 씬 카드 공통 -- */
.story-scene {
  position: relative;
  z-index: 1;
  max-width: 480px;
  margin: 24px auto;
  padding: 36px 28px;
  background: #fdfaf2;
  border-radius: 18px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.7s ease, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

@media (max-width: 520px) {
  .story-scene {
    margin: 20px 16px;
    padding: 28px 22px;
  }
}

.story-scene.show {
  opacity: 1;
  transform: translateY(0);
}

.scene-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 18px;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(30, 58, 111, 0.12);
}

.scene-num {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 28px;
  font-weight: 900;
  color: #3f3536;
  line-height: 1;
}

.scene-eyebrow {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.5px;
}

.scene-body {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  color: #2c2c2c;
}

.scene-body > * + * {
  margin-top: 18px;
}

.scene-body strong {
  font-weight: 800;
}

.scene-lead {
  font-size: 17px;
  font-weight: 500;
  line-height: 1.6;
  color: #555;
}

.scene-lead strong {
  font-weight: 800;
  color: #1a1a1a;
}

.scene-pivot {
  font-size: 19px;
  font-weight: 800;
  color: #3f3536;
  text-align: center;
  letter-spacing: -0.5px;
}

.scene-emphasis {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.6;
  letter-spacing: -0.3px;
}

.scene-emphasis strong {
  color: #3f3536;
  font-weight: 900;
}

.scene-quote {
  font-size: 17px;
  font-weight: 700;
  color: #c9a14a;
  text-align: center;
  letter-spacing: -0.3px;
  padding-bottom: 8px;
}

.scene-quote strong {
  color: #ff5757;
  font-weight: 900;
}

.scene-ctx-line {
  text-align: center;
  padding: 14px 16px;
  background: linear-gradient(135deg, rgba(30, 58, 111, 0.06) 0%, rgba(201, 161, 74, 0.08) 100%);
  border-radius: 10px;
  border-left: 3px solid #c9a14a;
}

.scene-finale {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.6;
  text-align: center;
  letter-spacing: -0.3px;
  padding: 16px;
  background: rgba(30, 58, 111, 0.05);
  border-radius: 10px;
}

.scene-finale strong {
  color: #3f3536;
  font-weight: 900;
}

/* SCENE 01: 10년 split */
.scene-split {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 12px;
  background: #fff;
  border: 1px solid rgba(30, 58, 111, 0.1);
  border-radius: 14px;
}

.split-item {
  flex: 1;
  text-align: center;
}

.split-num {
  display: block;
  font-family: 'Paperlogy', sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #3f3536;
  line-height: 1.1;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.split-text {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  line-height: 1.5;
}

.split-text strong {
  font-weight: 900;
  color: #1a1a1a;
}

.split-divider {
  width: 1px;
  height: 56px;
  background: rgba(0, 0, 0, 0.1);
}

/* SCENE 02: 49층 빅넘 */
.scene-bignum {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
  padding: 22px 12px;
  background: linear-gradient(135deg, #3f3536 0%, #2a2324 100%);
  border-radius: 14px;
  position: relative;
  overflow: hidden;
}

.scene-bignum::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
}

.bignum-prefix,
.bignum-suffix {
  font-size: 16px;
  font-weight: 700;
  color: rgba(255, 211, 107, 0.95);
}

.bignum-num {
  font-family: 'Paperlogy', sans-serif;
  font-size: 64px;
  font-weight: 900;
  color: #fff;
  line-height: 1;
  letter-spacing: -2px;
  text-shadow: 0 2px 16px rgba(255, 211, 107, 0.35);
}

.bignum-unit {
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  margin-right: 6px;
}

/* 일반 리스트 */
.scene-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.scene-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #444;
  border-left: 3px solid #3f3536;
}

.scene-list li + li {
  margin-top: 10px;
}

.scene-list li strong {
  font-weight: 800;
  color: #1a1a1a;
}

.list-icon {
  font-size: 18px;
  flex-shrink: 0;
}

/* SCENE 03: 체크리스트 */
.scene-checklist {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(30, 58, 111, 0.08);
}

.scene-checklist li {
  position: relative;
  padding: 14px 16px 14px 46px;
  font-size: 15px;
  font-weight: 600;
  color: #2c2c2c;
  letter-spacing: -0.3px;
}

.scene-checklist li + li {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.scene-checklist li::before {
  content: '✓';
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: #3f3536;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scene-checklist li strong {
  color: #3f3536;
  font-weight: 900;
}

/* SCENE 04: 상품 그리드 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.product-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 18px 6px;
  background: linear-gradient(135deg, #3f3536 0%, #5a4d4e 100%);
  border-radius: 12px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.product-pill::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
}

.pill-cat {
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 211, 107, 0.95);
  letter-spacing: 1px;
}

.pill-area {
  font-family: 'Paperlogy', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #fff;
  letter-spacing: -1px;
}

.feature-row {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.feature-item {
  flex: 1;
  text-align: center;
  padding: 12px 8px;
  background: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
  color: #3f3536;
  border: 1px solid rgba(30, 58, 111, 0.15);
  letter-spacing: 1px;
}

/* SCENE 05: 마무리 + 혜택 */
.story-scene-final {
  background: linear-gradient(180deg, #fdfaf2 0%, #fff8e3 100%);
}

.scene-brand {
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #3f3536;
  text-align: center;
  letter-spacing: -1px;
  padding: 16px 12px;
  border-top: 2px solid #3f3536;
  border-bottom: 2px solid #3f3536;
}

.benefit-card {
  background: #fff;
  border-radius: 14px;
  padding: 30px 20px 20px;
  position: relative;
  box-shadow: 0 4px 20px rgba(30, 58, 111, 0.08);
}

.benefit-ribbon {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #ff5757, #ff8a3d);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  padding: 7px 18px;
  border-radius: 50px;
  letter-spacing: -0.3px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(255, 87, 87, 0.35);
}

.benefit-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.benefit-list li {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 4px;
  font-size: 16px;
  font-weight: 600;
  color: #2c2c2c;
}

.benefit-list li + li {
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
}

.benefit-list li strong {
  font-weight: 900;
  color: #3f3536;
}

.benefit-icon {
  font-size: 22px;
  width: 28px;
  text-align: center;
  flex-shrink: 0;
}

.scene-warn {
  font-size: 16px;
  font-weight: 700;
  color: #555;
  text-align: center;
  line-height: 1.6;
}

.scene-warn strong {
  color: #ff5757;
  font-weight: 900;
}

.scene-cta {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 32px;
  background: linear-gradient(135deg, #3f3536, #2a2324);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.3px;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(30, 58, 111, 0.4);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.scene-cta:active {
  transform: scale(0.97);
}

.cta-arrow {
  font-size: 20px;
  font-weight: 900;
}

/* ===== 공통 sec / sec-inner ===== */
.sec { position: relative; }
.sec-inner { padding: 80px 28px; }

.sec-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--primary, #3f3536);
  margin-bottom: 20px;
}

.section-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
  line-height: 1.4;
}

/* ===== 사업 개요 ===== */
.sec-overview { background: #fafaf7; }
.sec-overview .sec-inner { padding: 60px 28px; }

.overview-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
  margin-bottom: 32px;
}

.overview-table {
  width: 100%;
  border-collapse: collapse;
  border-top: 2px solid #3f3536;
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
}

.overview-table th,
.overview-table td {
  padding: 16px 18px;
  text-align: left;
  border-bottom: 1px solid #e5e2da;
  font-size: 15px;
  line-height: 1.6;
  vertical-align: top;
}

.overview-table th {
  width: 34%;
  background: #f2efe7;
  color: #3f3536;
  font-weight: 700;
  white-space: nowrap;
}

.overview-table td {
  color: #333;
  font-weight: 500;
}

/* ===== 입지환경 2x2 ===== */
.location-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 28px 20px 8px;
}

.location-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #ece5d3;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(63, 53, 54, 0.05);
}

.loc-head {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background: #3f3536;
}

.loc-num {
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #c9a14a;
}

.loc-cat {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  line-height: 1.3;
}

.loc-detail {
  flex: 1;
  padding: 16px 16px 18px;
  font-size: 13.5px;
  line-height: 1.65;
  color: #444;
  word-break: keep-all;
}

@media (min-width: 768px) {
  .location-grid { max-width: 900px; margin: 0 auto; gap: 18px; }
  .loc-detail { font-size: 14.5px; }
}

/* ===== 프리미엄 6 ===== */
.sec-premium { background: #fdfaf2; }
.sec-premium .sec-inner { padding: 64px 20px; }

.premium-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.premium-card {
  background: #fff;
  border: 1px solid #ece5d3;
  border-radius: 14px;
  padding: 28px 16px 26px;
  text-align: center;
  transition: transform .25s ease, box-shadow .25s ease;
}

.premium-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(63, 53, 54, 0.08);
}

.premium-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #faf4e6;
  color: #c9a14a;
}

.premium-icon svg {
  width: 30px;
  height: 30px;
}

.premium-label {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  letter-spacing: 1px;
  color: #b9a778;
  margin-bottom: 12px;
}

.premium-label span {
  color: #c9a14a;
  font-weight: 700;
}

.premium-desc {
  font-size: 12.5px;
  color: #8a8378;
  line-height: 1.5;
  margin-bottom: 6px;
}

.premium-headline {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #2a2422;
  line-height: 1.45;
}

@media (min-width: 768px) {
  .premium-grid { grid-template-columns: repeat(3, 1fr); gap: 18px; }
  .sec-premium .sec-inner { max-width: 1000px; margin: 0 auto; }
}

/* ===== PREMIUM 8 ===== */
.sec-premium8 {
  background: #fdfaf2;
  padding: 8px 0 60px;
}

/* 상단 헤드 배너 */
.p8-banner {
  position: relative;
  max-width: 920px;
  margin: 0 20px 36px;
  padding: 18px 28px;
  border: 1.5px solid #c9a14a;
  border-radius: 8px;
  text-align: center;
}

@media (min-width: 940px) {
  .p8-banner {
    margin-left: auto;
    margin-right: auto;
  }
}

.p8-corner {
  position: absolute;
  width: 14px;
  height: 14px;
  background: #fdfaf2;
}

.p8-corner-tl { top: -8px; left: 26px; transform: rotate(45deg); border-top: 1.5px solid #c9a14a; border-left: 1.5px solid #c9a14a; }
.p8-corner-tr { top: -8px; right: 26px; transform: rotate(45deg); border-top: 1.5px solid #c9a14a; border-right: 1.5px solid #c9a14a; }
.p8-corner-bl { bottom: -8px; left: 26px; transform: rotate(45deg); border-bottom: 1.5px solid #c9a14a; border-left: 1.5px solid #c9a14a; }
.p8-corner-br { bottom: -8px; right: 26px; transform: rotate(45deg); border-bottom: 1.5px solid #c9a14a; border-right: 1.5px solid #c9a14a; }

.p8-banner-text {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.5px;
  line-height: 1.5;
  margin: 0;
}

.p8-accent {
  font-weight: 900;
  font-size: 1.05em;
}

.p8-banner-sep {
  display: inline-block;
  margin: 0 6px;
  color: #c9a14a;
}

.p8-banner-hl {
  font-weight: 900;
  color: #c9a14a;
}

@media (max-width: 520px) {
  .p8-banner {
    margin: 0 12px 28px;
    padding: 16px 18px;
  }
  .p8-banner-text {
    font-size: 14px;
  }
  .p8-corner-tl, .p8-corner-tr { top: -7px; }
  .p8-corner-bl, .p8-corner-br { bottom: -7px; }
}

/* 본문: 좌측 브랜드 + 우측 그리드 */
.p8-body {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 32px;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 760px) {
  .p8-body {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 0 16px;
  }
}

/* 좌측 브랜드 패널 */
.p8-brand {
  position: relative;
  text-align: center;
  padding: 28px 16px;
}

.p8-brand-arch {
  position: relative;
  border: 1.5px solid #c9a14a;
  border-bottom: none;
  border-radius: 220px 220px 0 0;
  padding: 36px 16px 28px;
  min-height: 360px;
}

.p8-brand-arch::before,
.p8-brand-arch::after {
  content: '';
  position: absolute;
  bottom: 0;
  width: 12px;
  height: 1.5px;
  background: #c9a14a;
}

.p8-brand-arch::before { left: -1.5px; }
.p8-brand-arch::after { right: -1.5px; }

.p8-brand-eyebrow {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 22px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.5px;
  margin: 0 0 4px;
}

.p8-brand-line {
  font-family: 'Roboto', 'Paperlogy', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 4px;
  margin: 0 0 16px;
}

.p8-brand-bignum {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 140px;
  font-weight: 900;
  color: #c9a14a;
  line-height: 1;
  display: block;
  letter-spacing: -4px;
}

.p8-brand-divider {
  width: 1px;
  height: 28px;
  background: #c9a14a;
  margin: 24px auto 18px;
}

.p8-brand-finale {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #555;
  margin: 0 0 6px;
  letter-spacing: -0.3px;
}

.p8-brand-name {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 800;
  color: #3f3536;
  margin: 0;
  letter-spacing: -0.3px;
}

@media (max-width: 760px) {
  .p8-brand-arch {
    border-radius: 180px 180px 0 0;
    min-height: 320px;
    padding: 28px 16px 24px;
  }
  .p8-brand-bignum { font-size: 110px; }
}

/* 우측 카드 그리드 */
.p8-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px 14px;
}

@media (max-width: 380px) {
  .p8-grid {
    grid-template-columns: 1fr;
  }
}

.p8-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 28px 22px 24px;
  background: #fff;
  border-radius: 4px;
  border-top: 2px solid #c9a14a;
  box-shadow: 0 4px 16px rgba(30, 58, 111, 0.05);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-height: 200px;
}

.p8-card::before {
  content: '';
  position: absolute;
  bottom: -10px;
  right: -8px;
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, rgba(201, 161, 74, 0.08) 0%, transparent 70%);
  pointer-events: none;
}

.p8-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(30, 58, 111, 0.12);
}

.p8-card-num {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 56px;
  font-weight: 900;
  color: #c9a14a;
  line-height: 1;
  letter-spacing: -2px;
  margin-bottom: 4px;
  display: block;
}

.p8-card-label {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 3px;
  margin: 0 0 10px;
}

.p8-card-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 20px;
  font-weight: 900;
  color: #1a1a1a;
  line-height: 1.25;
  letter-spacing: -0.7px;
  margin: 0 0 12px;
}

.p8-card-divider {
  width: 28px;
  height: 2px;
  background: #c9a14a;
  margin-bottom: 14px;
  border-radius: 1px;
}

.p8-card-desc {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 13.5px;
  font-weight: 500;
  color: #444;
  line-height: 1.65;
  letter-spacing: -0.3px;
  margin: 0;
  position: relative;
  z-index: 1;
}

@media (max-width: 520px) {
  .p8-card {
    padding: 22px 18px 20px;
    min-height: 170px;
  }
  .p8-card-num {
    font-size: 44px;
  }
  .p8-card-title {
    font-size: 17px;
  }
}

/* ===== 단지배치도 ===== */
.sec-layout { background: #fafaf7; }
.sec-layout .sec-inner { padding: 40px 28px 16px; }

.layout-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 세대정보 ===== */
.sec-unit { background: #fff; }
.sec-unit .sec-inner { padding: 40px 28px 28px; }

/* 유닛 탭 가로 스크롤 */
.unit-tabs-wrap {
  margin: 0 -28px 18px;
  padding: 0 28px 4px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.unit-tabs-wrap::-webkit-scrollbar { display: none; }

.unit-tabs {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 8px;
  padding-right: 28px;
}

.unit-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: #f5f5f5;
  border: 1px solid transparent;
  border-radius: 999px;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #666;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.unit-tab:hover { background: #ececec; }

.unit-tab.active {
  background: var(--primary, #3f3536);
  color: #fff;
  box-shadow: 0 6px 14px rgba(30, 58, 111, 0.25);
}

.unit-tab-tag {
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  background: #c9a14a;
  color: #fff;
  letter-spacing: -0.2px;
}

.unit-tab.active .unit-tab-tag {
  background: #ffd36b;
  color: #3f3536;
}

/* 기본/옵션 세그먼트 토글 */
.unit-mode {
  display: inline-flex;
  background: #f0f0f0;
  border-radius: 999px;
  padding: 4px;
  margin-bottom: 16px;
}

.unit-mode-btn {
  padding: 9px 22px;
  background: transparent;
  border: none;
  border-radius: 999px;
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #888;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: -0.3px;
}

.unit-mode-btn.active {
  background: #1a1a1a;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

/* 활성 유닛 라벨 */
.unit-current {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}

.unit-current-name {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #1a1a1a;
  letter-spacing: -1px;
}

.unit-current-tag {
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 11px;
  font-weight: 800;
  color: #fff;
  background: #c9a14a;
  padding: 3px 8px;
  border-radius: 4px;
  letter-spacing: -0.2px;
}

.unit-current-mode {
  margin-left: auto;
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #3f3536;
  background: rgba(30, 58, 111, 0.08);
  padding: 4px 10px;
  border-radius: 999px;
}

/* 평면도 + 디테일 스택 */
.unit-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.unit-figure {
  margin: 0;
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  background: #fafafa;
}

.unit-cap {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #888;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.unit-img {
  width: 100%;
  height: auto;
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ===== 커뮤니티 ===== */
.sec-community { background: #fafaf7; }
.sec-community .sec-inner { padding: 40px 28px 16px; }

.community-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 10. 방문예약 ===== */
.dp-register {
  background: #3f3536;
}

.dp-register-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.45);
  margin-top: -28px;
  margin-bottom: 36px;
}

.dp-form {
  max-width: 400px;
}

.dp-field {
  margin-bottom: 18px;
}

.dp-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.dp-req { color: #e8a0a0; }

.dp-field input[type="text"],
.dp-field input[type="tel"] {
  width: 100%;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  font-family: var(--font-family);
  font-size: 15px;
  color: #1a1a1a;
  outline: none;
  transition: border-color 0.2s ease;
}

.dp-field input:focus { border-color: #fff; }
.dp-field input::placeholder { color: #bbb; }

.dp-phone {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dp-phone input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.dp-phone span {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  flex-shrink: 0;
}

.dp-time-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.dp-date-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dp-date-wrap {
  position: relative;
  width: 100%;
}

.dp-date-input {
  width: 100%;
  padding: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #fff;
  font-family: var(--font-family);
  font-size: 14px;
  outline: none;
  color-scheme: dark;
  cursor: pointer;
}

.dp-date-input:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.dp-date-placeholder {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
  font-weight: 500;
  pointer-events: none;
  background: #3f3536;
  padding-right: 8px;
}

.dp-select {
  width: 100%;
  padding: 14px 36px 14px 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #fff;
  font-family: var(--font-family);
  font-size: 14px;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23fff' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
}

.dp-select:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.dp-select option {
  background: #3f3536;
  color: #fff;
}

.dp-later-btn {
  margin-top: 10px;
  width: 100%;
  padding: 13px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px dashed rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dp-later-btn.active {
  background: #fff;
  border-style: solid;
  border-color: #fff;
  color: #3f3536;
  font-weight: 800;
}

.dp-time-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.dp-time-btn {
  padding: 12px 10px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dp-time-btn:hover { background: rgba(255, 255, 255, 0.14); }

.dp-time-btn.active {
  background: #fff;
  color: #3f3536;
  border-color: #fff;
  font-weight: 700;
}

.dp-visit { display: flex; gap: 8px; }

.dp-visit-wrap {
  flex: 1;
  position: relative;
}

.dp-visit-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.dp-visit input,
.dp-visit select {
  width: 100%;
  padding: 14px 16px 14px 40px;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  font-family: var(--font-family);
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  appearance: none;
  transition: border-color 0.2s ease;
}

.dp-visit input:focus,
.dp-visit select:focus { border-color: #fff; }

.dp-visit select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
}

.dp-agree {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 24px 0 20px;
}

.dp-agree input[type="checkbox"] { display: none; }

.dp-check {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.dp-agree input:checked + .dp-check {
  background: #fff;
  border-color: #fff;
}

.dp-agree input:checked + .dp-check::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #3f3536;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.dp-submit {
  width: 100%;
  padding: 16px;
  background: #fff;
  color: #3f3536;
  border: none;
  border-radius: 12px;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.3s ease;
}

.dp-submit:active { background: #e8e8e8; }
.dp-submit:disabled { opacity: 0.6; cursor: not-allowed; }

.dp-success { text-align: center; padding: 40px 0; }

.dp-success-icon {
  width: 56px;
  height: 56px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
  margin: 0 auto 16px;
}

.dp-success h3 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.dp-success p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

/* ===== 트리플 1초 역세권 ===== */
.sec-triple {
  background: linear-gradient(180deg, #2a2324 0%, #3f3536 100%);
  padding: 80px 0 90px;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.sec-triple::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 20% 20%, rgba(255, 211, 107, 0.12), transparent 45%),
    radial-gradient(circle at 80% 80%, rgba(255, 211, 107, 0.08), transparent 45%);
  pointer-events: none;
}

.triple-inner {
  position: relative;
  z-index: 1;
  max-width: 560px;
  margin: 0 auto;
  padding: 0 24px;
}

.triple-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 5px;
  color: rgba(255, 211, 107, 0.9);
  margin: 0 0 18px;
}

.triple-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 32px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: -1px;
  line-height: 1.3;
  margin: 0 0 18px;
}

.triple-title strong {
  font-weight: 900;
  background: linear-gradient(135deg, #fff 0%, #ffd36b 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.triple-divider {
  width: 56px;
  height: 3px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
  margin: 0 auto 36px;
  border-radius: 2px;
}

.triple-img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto 32px;
  border-radius: 14px;
}

.triple-lines {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 32px;
}

.line-card {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 211, 107, 0.2);
  border-radius: 14px;
  padding: 18px 20px;
  text-align: left;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 16px;
}

.line-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding: 8px 14px;
  font-weight: 900;
  font-size: 13px;
  border-radius: 20px;
  letter-spacing: -0.3px;
  white-space: nowrap;
}

.line-1 .line-badge { background: #0052a4; color: #fff; }
.line-2 .line-badge { background: #00a84d; color: #fff; }
.line-u .line-badge { background: #b0ce18; color: #1a1a1a; }

.line-name {
  font-size: 13px;
  font-weight: 800;
  color: #ffd36b;
  margin: 0 0 4px;
  letter-spacing: -0.3px;
}

.line-desc {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.5;
  margin: 0;
}

.triple-hook {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 17px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
  letter-spacing: -0.4px;
  margin: 0;
}

.triple-hook strong { font-weight: 800; color: #fff; }
.triple-hook .triple-hl { color: #ffd36b; font-weight: 900; }

@media (max-width: 480px) {
  .sec-triple { padding: 60px 0 70px; }
  .triple-title { font-size: 26px; }
  .triple-hook { font-size: 15px; }
  .line-badge { min-width: 72px; font-size: 12px; padding: 7px 10px; }
}

/* ===== 상품 그리드 2컬럼 변형 ===== */
.product-grid-2 { grid-template-columns: repeat(2, 1fr); }

/* ===== checklist tight (4번 씬 전용) ===== */
.scene-checklist-tight li {
  padding: 12px 16px 12px 42px;
  font-size: 14px;
}

</style>
